module.exports = __webpack_public_path__ + "static/media/md-mic.8667f358.svg";